module.exports = __webpack_public_path__ + "img/box2_title.3cc69252.png";